import { createTheme } from "@mui/material";
import { nlNL } from '@mui/material/locale';

export const muiTheme = createTheme({
  typography: {
    fontFamily: "Catamaran, sans-serif",
    fontDisplay: "swap",
    fontWeight: 400,
    fontSize: 12,
    htmlFontSize: 12,
    button: {
      fontSize: 12,
    },
  },
  palette: {
    primary: {
      main: "#324E83",
    },
    secondary: {
      main: "#FFFFFF",
    },
  },
}, nlNL);
